"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_PAYMENT_REQUEST_EXAMPLES = exports.createPaymentRequestSchema = void 0;
/**
 * Request contract for the 1 Payment endpoint. Field shapes mirror
 * `PaymentProcessingService.CreatePaymentInput`/`CreatePaymentLineInput`
 * (`backend/src/modules/financial/payment/payment-processing.service.ts`,
 * frozen, Stage 5C.2) as orchestrated by `PaymentApplicationService`
 * (frozen, Stage 5C.3). Money is integer paise throughout (ADR-018).
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
const createPaymentLineRequestSchema = zod_1.z.object({
    paymentModeId: zod_1.z.string().uuid(),
    amount: zod_1.z.number().int().positive(),
    referenceNumber: zod_1.z.string().optional(),
});
exports.createPaymentRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid().optional(),
    /**
     * The desk this collection happens at.
     *
     * Optional, because this endpoint also serves genuine back-office
     * collections that occur at no counter. When it IS supplied the server
     * resolves the cashier's open session from it and stamps every payment line
     * with that session — which is what stops `cash_session_id` being NULL.
     * A counter the caller does not hold a session at is refused, not silently
     * ignored: the id is verified, never trusted.
     */
    counterId: zod_1.z.string().uuid().optional(),
    /** The visit this collection belongs to, when the caller knows it. */
    encounterId: zod_1.z.string().uuid().optional(),
    transactionType: zod_1.z.enum(['RECEIPT', 'ADVANCE', 'DEPOSIT', 'REFUND', 'ADJUSTMENT']),
    totalAmount: zod_1.z.number().int().positive(),
    paymentDate: zod_1.z.coerce.date().optional(),
    remarks: zod_1.z.string().optional(),
    lines: zod_1.z.array(createPaymentLineRequestSchema).min(1),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_PAYMENT_REQUEST_EXAMPLES = {
    createPayment: {
        branchId: '33333333-3333-3333-3333-333333333333',
        patientId: '44444444-4444-4444-4444-444444444444',
        transactionType: 'RECEIPT',
        totalAmount: 150000,
        lines: [
            { paymentModeId: 'dddddddd-dddd-dddd-dddd-dddddddddddd', amount: 100000 },
            { paymentModeId: 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee', amount: 50000 },
        ],
    },
};
//# sourceMappingURL=financial-payment.request.js.map